import React from 'react';
import FrontLoader from './FrontLoader';
import './page-loading-shell.scss';

type PageLoadingShellProps = {
  loading: boolean;
  children: React.ReactNode;
  skeleton: React.ReactNode;
  className?: string;
};

/** Shared blur + skeleton loading shell (same pattern as DashboardHome). */
export default function PageLoadingShell({
  loading,
  children,
  skeleton,
  className = '',
}: PageLoadingShellProps) {
  return (
    <div
      className={`page-loading-shell${className ? ` ${className}` : ''}${
        loading ? ' page-loading-shell--loading' : ''
      }`}
      aria-busy={loading}
    >
      {loading ? <FrontLoader /> : null}
      {loading ? skeleton : <div className="page-loading-shell__content">{children}</div>}
    </div>
  );
}
